import SqftStore from "../../../store/sqftStore";
import store from "../../../../../../../store";
import sqftSlabManager from "../../../store/sqftSlabManager";
import sqftShapeIntersectionsManager from "../../../store/sqftShapeIntersectionsManager";
import sqftImageManager from "../../../store/sqftImageManager";
import {
  detectSlabConflicts,
  handleOpenSlabModeConflict
} from "../../../../popup/modalFix/slabFix/slabModeConflictHelper";
import {setSqftSlabConflicts} from "../../../../../../../actions/sqftSlabFunctions";

export default class ShapeIntersections {
  __shape;
  overlappedWithShapeIds = [];

  constructor(shape) {
    this.__shape = shape;
  }

  setOverlappedWithShapeIds = (ids) => {
    this.overlappedWithShapeIds = ids
  }

  addOverlappedWithShape = (id) => {
    if (!this.overlappedWithShapeIds.includes(id)) {
      this.overlappedWithShapeIds.push(id);
    }
  }

  removeOverlappedWithShape = (id) => {
    if (this.overlappedWithShapeIds.includes(id)) {
      this.overlappedWithShapeIds = this.overlappedWithShapeIds.filter(overlappedId => id !== overlappedId);
    }
  }

  /**
   *  use handleSlabPlaceholderAndSlabImageIntersections
   * This will update features for the slab placeholders and detect conflicts,
   *  in case we have conflicts open slab conflict popup
   */
  // handleSlabPlaceholderIntersections = () => {
  //   if (SqftStore.isSlabMode()) {
  //     const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
  //     if (slabPlaceHolderShapes.length) {
  //
  //       // if (this.__shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
  //       //   this.onSlabPlaceHolderMove();
  //       // } else {
  //       //   this.onCountertopShapeMove(slabPlaceHolderShapes);
  //       // }
  //
  //       //sqftShapeIntersectionsManager.updateShapesIntersections();
  //       sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
  //
  //       const shapesWithConflict = detectSlabConflicts();
  //       handleOpenSlabModeConflict(shapesWithConflict).then(r => void r);
  //
  //       // if (shouldShowSlabConflict) {
  //       //
  //       // } else {
  //       //   sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
  //       //
  //       //   const errorCallback = () => {
  //       //     this.__shape.shapeMemory.restoreShapePosition();
  //       //     this.__shape.resetMouseDown();
  //       //     sqftShapeIntersectionsManager.updateShapesIntersections();
  //       //   }
  //       //
  //       //   sqftShapeIntersectionsManager.showSlabPlaceHolderErrorMessage(slabPlaceHolderShapes, errorCallback);
  //       // }
  //     }
  //   }
  // }

  /**
   * 1. This will take FIRST intersection between shape ans the slab and assign feature from shape to slab
   * 2. Then it will show Slab conflict popup if andy slab conflict exist
    */
  handleSlabPlaceholderAndSlabImageIntersections = () => {
    if (!SqftStore.isSlabMode()) {
      return;
    }

    const slabImages = sqftImageManager.getSlabImages();
    const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();

    if (!slabImages.length && !slabPlaceHolderShapes.length) {
      return;
    }

    sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
    sqftShapeIntersectionsManager.updateSlabImagesFeature();

    const shapeIdsWithConflict = detectSlabConflicts();

    // If detector says "no conflicts" — sync store to empty (authoritative reset)
    if (Array.isArray(shapeIdsWithConflict) && shapeIdsWithConflict.length === 0) {
      store.dispatch(setSqftSlabConflicts([]));
    }

    handleOpenSlabModeConflict(shapeIdsWithConflict).then(() => undefined);
  };

  // onSlabPlaceHolderMove = () => {
  //   const counterTopShapes = sqftShapeManager.getCounterTopShapes();
  //   let overlapsWithIds = [];
  //   this.setOverlappedWithShapeIds([]);
  //
  //   for (const counterTopShape of counterTopShapes) {
  //     const shapeIntersections = ShapeHelper.getTwoShapesIntersections(this.__shape, counterTopShape);
  //     const shapeIds = Object.keys(shapeIntersections);
  //     if (shapeIds.length) {
  //       this.__shape.setFeatureId(clone(counterTopShape.featureId))
  //       overlapsWithIds.push(shapeIds[0]);
  //     }
  //     //console.log("shapeIntersections", shapeIntersections);
  //   }
  //   this.setOverlappedWithShapeIds(overlapsWithIds);
  // }
  //
  // onCountertopShapeMove = (slabPlaceHolderShapes) => {
  //   for (const slabPlaceHolderShape of slabPlaceHolderShapes) {
  //     slabPlaceHolderShape.shapeIntersections.removeOverlappedWithShape(this.__shape.id);
  //     const shapeIntersections = ShapeHelper.getTwoShapesIntersections(slabPlaceHolderShape, this.__shape);
  //     //console.log("shapeIntersections", shapeIntersections);
  //     const shapeIds = Object.keys(shapeIntersections);
  //     if (shapeIds.length) {
  //       slabPlaceHolderShape.setFeatureId(clone(this.__shape.featureId));
  //       slabPlaceHolderShape.shapeIntersections.addOverlappedWithShape(+shapeIds[0]);
  //     }
  //   }
  // }


}
